
import React from 'react';
import { FacilityOrderNewFlowUSIntakeFindAndReplaceModalTemplate} from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowUSIntakeFindAndReplaceModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowUSIntakeFindAndReplaceModalStore(rootStore, componentProps), 'facilityOrderNewFlowUSIntakeFindAndReplaceModalStore')
@observer
class FacilityOrderNewFlowUSIntakeFindAndReplaceModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowUSIntakeFindAndReplaceModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowUSIntakeFindAndReplaceModal;
